import _classCallCheck from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/createClass.js";

var Subscribable = /*#__PURE__*/function () {
  function Subscribable() {
    _classCallCheck(this, Subscribable);

    this.listeners = new Set();
    this.subscribe = this.subscribe.bind(this);
  }

  _createClass(Subscribable, [{
    key: "subscribe",
    value: function subscribe(listener) {
      var _this = this;

      var identity = {
        listener: listener
      };
      this.listeners.add(identity);
      this.onSubscribe();
      return function () {
        _this.listeners.delete(identity);

        _this.onUnsubscribe();
      };
    }
  }, {
    key: "hasListeners",
    value: function hasListeners() {
      return this.listeners.size > 0;
    }
  }, {
    key: "onSubscribe",
    value: function onSubscribe() {// Do nothing
    }
  }, {
    key: "onUnsubscribe",
    value: function onUnsubscribe() {// Do nothing
    }
  }]);

  return Subscribable;
}();

export { Subscribable };